"use client";

const CURRENT_YEAR = Number(new Date().getFullYear());
const generateYears = () => {
    const years = [];
    const endYear = 2015;
    for (let year = CURRENT_YEAR; year >= endYear; year--) {
        years.push(year);
    }
    return years;
};

export default function Years({ year, setYear }: { year: number, setYear: any }) {

    const years = generateYears();

    return (
        <div className="flex flex-row gap-2 md:flex-col items-center py-2 md:py-8 bg-white">
            {years?.map((y: number, index: number) => {
                const isCurrent = y === year;
                const opacityPercentage = isCurrent ? 100 : Math.max(20, 100 - index * 15);
                const fontSizeRem = isCurrent ? 1.8 : Math.max(0.8, 1.8 - (index+1) * 0.3);
                const color = isCurrent ? 'text-black' : 'text-gray-500';
                const fontWeight = isCurrent ? 'font-semibold' : 'font-regular';
                return (
                    <div
                        key={y}
                        className={`
                            transition-all duration-300 my-1 cursor-pointer
                            ${color} ${fontWeight} 
                         `}
                        style={{
                            fontSize: `${fontSizeRem}rem`,
                            opacity: `${opacityPercentage / 100}`,
                            lineHeight: '1.2',
                        }}
                        onClick={() => {
                            setYear(y);
                            const firstItemOfYear = document.querySelector(`[data-year="${y}"]`);
                            if (firstItemOfYear) {
                                firstItemOfYear.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                });
                            } else {
                              //  window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        }}
                    >
                        {y}
                    </div>
                )
            })}
        </div>
    );
}
